import { PageTypes } from "./types";
import { APP_PATHS } from "./constants";
import Logger from "@cappelendamm/logger";

export const getSearchParamsFromUrl = (
  url?: string | null,
): URLSearchParams => {
  if (!url) return new URLSearchParams();
  try {
    return new URL(url).searchParams;
  } catch (e) {
    Logger.warn(`Unable to parse url: ${url}. \n${e}`);
    return new URLSearchParams();
  }
};

export const getPageLink = ({
  pageType,
  searchParams,
  params,
  url,
}: {
  pageType: PageTypes;
  params?: string | null;
  searchParams?: URLSearchParams;
  url?: string | null;
}) => {
  if (pageType === "external") return url ?? "";
  const pathname = [APP_PATHS[pageType], params]
    .filter(Boolean)
    .join("/")
    .replace(/\/+/g, "/");
  const href = [pathname, searchParams?.toString()].filter(Boolean).join("?");
  return href;
};
